import "./App.css";

import Navbar from "./components/Navbar";
import Header from "./components/Header";

import Hero from "./components/Hero";
import About from "./components/About";
import FeaturedMenu from "./components/FeaturedMenu";
import Gallery from "./components/Gallery";
import Events from "./components/Events";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Navbar />

      <main>
        <Hero />
        <About />
        <FeaturedMenu />
        <Gallery />
        <Events />
        <Testimonials />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;